export default function PasswordStrengthIndicator({ password }) {
  const checks = {
    length: { test: password.length >= 8, label: 'At least 8 characters' },
    uppercase: { test: /[A-Z]/.test(password), label: 'One uppercase letter' },
    lowercase: { test: /[a-z]/.test(password), label: 'One lowercase letter' },
    number: { test: /[0-9]/.test(password), label: 'One number' },
    special: { test: /[!@#$%^&*(),.?":{}|<>]/.test(password), label: 'One special character' },
  };

  const passedChecks = Object.values(checks).filter(c => c.test).length;
  const strength = passedChecks === 0 ? 0 : (passedChecks / 5) * 100;
  
  const getColor = () => {
    if (strength < 40) return 'bg-red-500';
    if (strength < 60) return 'bg-orange-500';
    if (strength < 80) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const getLabel = () => {
    if (strength < 40) return 'Weak';
    if (strength < 60) return 'Fair';
    if (strength < 80) return 'Good';
    return 'Strong';
  };

  if (!password) return null;

  return (
    <div className="mt-2 space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div 
            className={`h-full transition-all duration-300 ${getColor()}`}
            style={{ width: `${strength}%` }}
          />
        </div>
        <span className={`text-sm font-medium ${
          strength < 40 ? 'text-red-500' :
          strength < 60 ? 'text-orange-500' :
          strength < 80 ? 'text-yellow-500' :
          'text-green-500'
        }`}>
          {getLabel()}
        </span>
      </div>
      
      <div className="space-y-1 text-xs">
        {Object.entries(checks).map(([key, { test, label }]) => (
          <div key={key} className={`flex items-center gap-2 ${test ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}`}>
            <span>{test ? '✓' : '○'}</span>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
